import React, { useEffect, useState } from 'react';
import {
  useMediaQuery,
  Typography,
  Box,
  Card,
  CardContent,
} from '@mui/material';

const PlanTypeIndicator = ({ option }) => {
  return (
    <div
      style={{
        position: 'absolute',
        top: option === 1 ? -25 : option === 2 ? 230 : 70,
        right: option === 1 ? -40 : option === 2 ? -40 : -60,
        display: 'flex',
        alignItems: 'center',
        zIndex: -1,
      }}
    >
      <div
        style={{
          width: '114px',
          height: '114px',
          borderRadius: '50%',
          backgroundColor:
            option === 1 ? '#D7F1FD' : option === 2 ? '#DBF7EB' : '#FFEED6',
        }}
      />
    </div>
  );
};

export default function CardPlanCode({ selected, onClick, plan, option }) {
  const priceNum = Number(plan.recurlyPlanCodePrice);
  const montlyPrice = priceNum / 12;

  const professionalBullets = [
    'Join any advisory boards on our platform',
    'Make your Advisor Profile live in our directory',
    'Establish your Advisor Rate ($2,000–$10,000)',
    'Engage in senior-level networking',
    'Access perks & benefits for board members',
  ];

  const executiveBullets = [
    'Your own dedicated contact at AdvisoryCloud',
    'Personalized plan for leveraging advisory work',
    'Saves time, letting you be on more boards',
    'Priority access to boards with benefits & perks',
    'Quarterly check-ins and recommendations',
  ];
  const selectedBullets = option === 1 ? professionalBullets : executiveBullets;

  function displayMoneyAmounts(number) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
    }).format(Math.ceil(number));
  }

  return (
    <Card
      onClick={onClick}
      sx={{
        width: '370px',
        height: '326px',
        letterSpacing: '-0.43px',
        border: '1px solid',
        borderColor: selected ? '#3171F6' : '#C7D0DE',
        borderRadius: '15px',
        cursor: 'pointer',
        position: 'relative',
        padding: '10px',
        zIndex: 1,
        boxShadow: selected ? '0 0 0 2px #3171F6' : 'none',
      }}
    >
      <Typography
        sx={{
          color: '#232B35',
          fontSize: '14px',
          fontStyle: 'normal',
          fontWeight: 400,
          lineHeight: '15px',
          letterSpacing: '-0.43px',
          marginTop: '10px',
          mb: '25px',
          display: 'block',
        }}
      >
        {option == 1 ? (
          <span>
            🎁 Current special{' '}
            <span style={{ fontWeight: 700 }}>Save $500!</span>
          </span>
        ) : (
          <span>
            🎁 Current special{' '}
            <span style={{ fontWeight: 700 }}>Save $1,000!</span>
          </span>
        )}
      </Typography>
      <Typography
        sx={{
          color: '#232B35',
          fontSize: '16px',
          fontStyle: 'normal',
          lineHeight: '24px',
          letterSpacing: '-0.43px',
          marginTop: '10px',
          mb: '25px',
        }}
      >
        <span style={{ fontWeight: 700 }}>
          Only {displayMoneyAmounts(priceNum)} / year
        </span>{' '}
        (normally {displayMoneyAmounts(priceNum + (option === 1 ? 500 : 1000))})
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        {selectedBullets.map((text, index) => (
          <Typography
            key={index}
            sx={{
              color: '#232B35',
              fontSize: '14px',
              fontStyle: 'normal',
              fontWeight: 400,
              lineHeight: '24px',
              letterSpacing: '-0.43px',
              marginBottom: '5px',
            }}
          >
            <span
              style={{
                color: '#0F78FD',
                fontWeight: 700,
                marginRight: '5px',
              }}
            >
              ✓
            </span>{' '}
            {text}
          </Typography>
        ))}
      </Box>
      <PlanTypeIndicator option={option} />
    </Card>
  );
}
